import Vue from 'vue'
import ApiService from '@/services/api.service'
import App from './App.vue'
import { store } from './store'
import router from './router'
import moment from "moment";

/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core'

/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

/* import specific icons */
import { faCamera, faLocationDot, faCaretDown, faXmark, faCheck, faArrowDown, faChevronDown, faEnvelope, faPhone } from '@fortawesome/free-solid-svg-icons'

/* add icons to the library */
library.add(faCamera)
library.add(faLocationDot)
library.add(faCaretDown)
library.add(faArrowDown)
library.add(faChevronDown)
library.add(faXmark)
library.add(faCheck)
library.add(faEnvelope)
library.add(faPhone)

/* add font awesome icon component */
Vue.component('font-awesome-icon', FontAwesomeIcon)

// import '@/scss/app.scss';

Vue.config.productionTip = false;
Vue.config.devtools = process.env.NODE_ENV != 'production';

const baseUrl = process.env.NODE_ENV == "test" ? process.env.VUE_APP_OB_API_TESTING : process.env.VUE_APP_OB_API;

const number_format_options = {
    style: 'currency',
    currency: 'EUR'
};
ApiService.init(baseUrl)

function nl2br(str, is_xhtml) {
    if (typeof str === 'undefined' || str === null) {
        return '';
    }
    const breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
    return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
}

Vue.filter('number_format', n => new Intl.NumberFormat('de-DE', number_format_options).format(n));
Vue.filter('decimal_format', n => new Intl.NumberFormat('de-DE', { style: 'decimal', maximumFractionDigits: 2 }).format(n));
Vue.filter('nl2br', text => nl2br(text));
Vue.mixin({
    methods: {
        colorizeErrors(e) {
            const el = e.target;
            if (el.classList.contains('error')) {
                el.classList.add('error--colored');
            }
        },
        scrollTop: () => {
            const scrollOptions = {
                top: 0,
                left: 0,
                behavior: "smooth",
            };
            window.scrollTo(scrollOptions);
        },
        scrollTo: (options) => {
            const scrollOptions = {
                top: 0,
                left: 0,
                behavior: "smooth",
            };
            window.scrollTo({ ...scrollOptions, ...options} );
        },
        goToPath(options) {
            const pathOptions = {
                ...{
                    name: '/',
                    step: 1
                },
                ...options
            };
            router.push(pathOptions.name);
            store.dispatch("orders/navigate", pathOptions.step);
        },
        checkFormCompletition(e) {
            if (e === null) {
                return;
            }
            const targetField = !e ? false : e.target;
            const targetWrapper = targetField.closest('div');
            const isDateField = moment(e).isValid();
            const targetFormGroup = !isDateField ?
                targetField.closest(".form-group") :
                false;
            if (targetFormGroup) {
                targetFormGroup.classList.add("focused");
            }

            if (targetField.required || targetField.classList.contains('required')) {
                if (!targetField.value) {
                    targetWrapper.classList.add('has-error');
                } else {
                    targetWrapper.classList.remove('has-error');
                }
            }
        },
    }
})

new Vue({
    store,
    router,
    render: h => h(App),
}).$mount('#app')


// new Vue({
//     store,
//     el: "#statusbar",
//     render: h => h(StatusBar)
// })